import React, { useState } from "react";
import "./ImportCSV.css";
import TemplateSetting from "../../../API/APIServices/TemplateSetting";
import Loader from "../../Props/Loader";
import Transaction from "../../../API/APIServices/Transaction";
import Swal from "sweetalert2";
import { upperCase } from "lodash";

const CsvModalSaleInvoice = ({
  onClose,
  ImportType,
  TransAccountId,
  ReferenceNumber,
  setChangeInData,
  GetProductDataFunction,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const [csvData, setCsvData] = useState(null);
  const [csvFile, setCsvfile] = useState(null);
  const [showSuccess, setshowSuccess] = useState(false);
  const [ItemsArray, setItemsArray] = useState([]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setCsvfile(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const rows = text.split("\n").map((row) => row.split(","));
        setCsvData(rows);
      };
      reader.readAsText(file);
    }
  };

  const handleClose = () => {
    setCsvData(null);
    onClose();
  };
  //   const handleCSVUpload = async (e) => {
  //     try {
  //       setIsLoading(true);
  //       const data = await TemplateSetting.ImportItemCsvExcelFileForTransaction(
  //         csvFile,
  //         ImportType
  //       );
  //       if (data.isSuccess) {
  //         ;
  //         console.log(data);

  //         for (let i = 0; i < data.result.length; i++) {
  //           const selectedItem = data.result[i];
  //           const ItemMasterId =
  //             selectedItem.id2 || selectedItem.itmId_d2 || selectedItem.id;
  //           // const ItemData = await ItemMasterAPI.GetItemMasterById(ItemMasterId);
  //           const filterData = {
  //             searchTypeId: 4,
  //             itmId_d2: ItemMasterId,
  //           };
  //           const ItemDataByid =
  //             await Transaction.GetBarcodeSerialBatchNoForItemFetch(filterData);
  //           if (ItemDataByid) {
  //             setItemsArray((prevArray) => {
  //               const existingIndex = prevArray.findIndex(
  //                 (item) => item.d2_Id === ItemDataByid.d2_Id
  //               );

  //               if (existingIndex !== -1) {
  //                 // Item already exists, update its Qty
  //                 const updatedArray = [...prevArray];
  //                 const existingItem = updatedArray[existingIndex];
  //                 updatedArray[existingIndex] = {
  //                   ...existingItem,
  //                   Qty: e.target.value || "", // Increment quantity
  //                 };
  //                 // setLoading(false);
  //                 return updatedArray;
  //               } else {
  //                 // Item does not exist, add new row
  //                 const newRow = {
  //                   d1_Id: ItemDataByid.d1_Id || "",
  //                   d2_Id: ItemDataByid.d2_Id || "",
  //                   productName: ItemDataByid.productName || "",
  //                   parentGrp: ItemDataByid.parentGrp2 || "",
  //                   parentGrpName: ItemDataByid.parentGrpName || "",
  //                   productUnitName: ItemDataByid.productUnitName || "",
  //                   productUnit: ItemDataByid.productUnit || "",
  //                   productAltUnit: ItemDataByid.productAltUnit || "",
  //                   unitConvFactor: ItemDataByid.unitConvFactor || "",
  //                   enableBarcode: ItemDataByid.enableBarcode || "",
  //                   defaultBarcode: ItemDataByid.Barcode || "",
  //                   batchNos: ItemDataByid.batchDetails || [],
  //                   taxCategory1: ItemDataByid.taxCategory1 || "",
  //                   taxLimit: ItemDataByid.taxLimit || "",
  //                   taxCategory2: ItemDataByid.taxCategory2 || "",
  //                   hsnCode: ItemDataByid.hsnCode || "",
  //                   shortDescription: "",
  //                   Qty: e.target.value === 0 ? 1 : e.target.value || 1,
  //                   FreeQty: ItemDataByid.FreeQty || "",
  //                   purchasePrice: ItemDataByid.purchasePrice || "",
  //                   purchaseDiscount: ItemDataByid.purchaseDiscount || "",
  //                   saleProfit: ItemDataByid.saleProfit || "",
  //                   salePrice: ItemDataByid.salePrice || "",
  //                   saleDiscount: ItemDataByid.saleDiscount || "",
  //                   itemPrice:
  //                     Number(TransAccountId) === 216
  //                       ? ItemDataByid.salePrice
  //                       : Number(TransAccountId) === 215
  //                       ? ItemDataByid.purchasePrice
  //                       : ItemDataByid.salePrice,

  //                   costPrice: ItemDataByid.costPrice || "",
  //                   mrpPrice: ItemDataByid.mrpPrice || "",
  //                   DiscPer:
  //                     Number(TransAccountId) === 216
  //                       ? ItemDataByid.saleDiscount
  //                       : Number(TransAccountId) === 215
  //                       ? ItemDataByid.purchaseDiscount
  //                       : ItemDataByid.saleDiscount,
  //                   DiscAmt: ItemDataByid.DiscAmt || "",
  //                   TotalAmt: ItemDataByid.TotalAmt || "",
  //                   // salePriceForPur: ItemDataByid.salePriceForPur || 0,
  //                   purPageSalePrice: ItemDataByid.salePrice || "",
  //                   availableQuantity: ItemDataByid.availableQuantity || "",
  //                   lens_Eye: ItemDataByid.lens_Eye || "",
  //                   lens_SPH: ItemDataByid.lens_SPH || "",
  //                   lens_CYL: ItemDataByid.lens_CYL || "",
  //                   lens_AXIS: ItemDataByid.lens_AXIS || "",
  //                   lens_Dia: ItemDataByid.lens_Dia || "",
  //                   lens_Add: ItemDataByid.lens_Add || "",
  //                   enableSerialNo: ItemDataByid.enableSerialNo || "",
  //                   taxCat1_Cgst: ItemDataByid.taxCat1_Cgst || "",
  //                   taxCat1_Sgst: ItemDataByid.taxCat1_Sgst || "",
  //                   taxCat1_Igst: ItemDataByid.taxCat1_Igst || "",
  //                   taxCat1_Cess: ItemDataByid.taxCat1_Cess || "",
  //                   taxLimit: ItemDataByid.taxLimit || "",
  //                   taxCategory2: ItemDataByid.taxCategory2 || "",
  //                   taxCat2_Cgst: ItemDataByid.taxCat2_Cgst || "",
  //                   taxCat2_Sgst: ItemDataByid.taxCat2_Sgst || "",
  //                   taxCat2_Igst: ItemDataByid.taxCat2_Igst || "",
  //                   taxCat2_Cess: ItemDataByid.taxCat2_Cess || "",
  //                   rowIndex: 0,
  //                 };
  //                 // setLoading(false)
  //                 return [...prevArray, newRow];
  //               }
  //             });
  //           }
  //           // You can process ItemData here if needed
  //         }

  //         var upload = await SaveLensItemData();
  //         if (upload) {
  //           setshowSuccess(true);
  //           setIsLoading(false);
  //           setTimeout(() => {
  //             onClose(false);
  //           }, 1500);
  //         }
  //       } else {
  //         alert("Failed to upload CSV file!");
  //         setIsLoading(false);
  //       }
  //     } catch (error) {
  //       alert("Failed to upload CSV file!");
  //       console.log(error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  const handleCSVUpload = async (e) => {
    try {
      setIsLoading(true);
      const data = await TemplateSetting.ImportItemCsvExcelFileForTransaction(
        csvFile,
        ImportType
      );
      debugger;
      if (data.isSuccess) {
        var nullData = data.result.filter(
          (item) =>
            item.id2 === null || item.itmId_d2 === null || item.id === null
        );

        if (nullData.length > 0) {
          const excludedKeys = ["id", "mrP_PRICE", "enablE_BRCD", "unit" , "qty", "puR_PRICE" , "salE_PRICE"];

          const nullItemsHtml = nullData
            .map((item) => {
              const itemLine = Object.entries(item)
                .filter(([key]) => !excludedKeys.includes(key))
                .map(
                  ([key, value]) => `${key.toUpperCase()}: ${value !== null ? value : "N/A"}`
                )
                .join(" , ");
              return itemLine;
            })
            .join("<br>");

          Swal.fire({
            icon: "error",
            title: `${nullData.length} Items Not Found`,
            html: nullItemsHtml,
            width: "700px",
            customClass: {
              title: "swal2-custom-title",
              confirmButton: "my-confirm-button",
              cancelButton: "my-cancel-button",
              popup: "swal2-custom-popup",
              htmlContainer: "swal2-custom-text",
              icon: "swal2-custom-icon",
            },
          });
          return;
        }

        let items = [];
        for (let i = 0; i < data.result.length; i++) {
          const selectedItem = data.result[i];
          const ItemMasterId =
            selectedItem.id2 || selectedItem.itmId_d2 || selectedItem.id;
          if (!ItemMasterId) {
            Swal.fire({
              icon: "error",
              title: "Some Items Not Found",
              text: "Check the CSV file and try again",
              width: "250px",
              customClass: {
                title: "swal2-custom-title",
                confirmButton: "my-confirm-button",
                cancelButton: "my-cancel-button",
                popup: "swal2-custom-popup",
                htmlContainer: "swal2-custom-text",
                icon: "swal2-custom-icon",
              },
            });
            return;
          }
          const filterData = {
            searchTypeId: 4,
            itmId_d2: ItemMasterId,
          };
          const ItemDataByid =
            await Transaction.GetBarcodeSerialBatchNoForItemFetch(filterData);
          if (ItemDataByid) {
            const newRow = {
              d1_Id: ItemDataByid.d1_Id || "",
              d2_Id: ItemDataByid.d2_Id || "",
              productName: ItemDataByid.productName || "",
              parentGrp: ItemDataByid.parentGrp2 || "",
              parentGrpName: ItemDataByid.parentGrpName || "",
              productUnitName: ItemDataByid.productUnitName || "",
              productUnit: ItemDataByid.productUnit || "",
              productAltUnit: ItemDataByid.productAltUnit || "",
              unitConvFactor: ItemDataByid.unitConvFactor || "",
              enableBarcode: ItemDataByid.enableBarcode || "",
              defaultBarcode:
                selectedItem.barcode || ItemDataByid.Barcode || "",
              batchNos: ItemDataByid.batchDetails || [],
              taxCategory1: ItemDataByid.taxCategory1 || "",
              taxLimit: ItemDataByid.taxLimit || "",
              taxCategory2: ItemDataByid.taxCategory2 || "",
              hsnCode: ItemDataByid.hsnCode || "",
              shortDescription: "",
              Qty: selectedItem.qty || 1,
              FreeQty: ItemDataByid.FreeQty || "",
              purchasePrice: ItemDataByid.purchasePrice || "",
              purchaseDiscount: ItemDataByid.purchaseDiscount || "",
              saleProfit: ItemDataByid.saleProfit || "",
              salePrice: ItemDataByid.salePrice || "",
              saleDiscount: ItemDataByid.saleDiscount || "",
              itemPrice:
                Number(TransAccountId) === 216
                  ? selectedItem.salE_PRICE || ItemDataByid.salePrice
                  : Number(TransAccountId) === 215
                  ? selectedItem.puR_PRICE || ItemDataByid.purchasePrice
                  : selectedItem.salE_PRICE || ItemDataByid.salePrice,
              costPrice: ItemDataByid.costPrice || "",
              mrpPrice: selectedItem.mrP_PRICE || ItemDataByid.mrpPrice || "",
              DiscPer:
                Number(TransAccountId) === 216
                  ? ItemDataByid.saleDiscount
                  : Number(TransAccountId) === 215
                  ? ItemDataByid.purchaseDiscount
                  : ItemDataByid.saleDiscount,
              DiscAmt: ItemDataByid.DiscAmt || "",
              TotalAmt: ItemDataByid.TotalAmt || "",
              purPageSalePrice: ItemDataByid.salePrice || "",
              availableQuantity: ItemDataByid.availableQuantity || "",
              lens_Eye: ItemDataByid.lens_Eye || "",
              lens_SPH: ItemDataByid.lens_SPH || "",
              lens_CYL: ItemDataByid.lens_CYL || "",
              lens_AXIS: ItemDataByid.lens_AXIS || "",
              lens_Dia: ItemDataByid.lens_Dia || "",
              lens_Add: ItemDataByid.lens_Add || "",
              enableSerialNo: ItemDataByid.enableSerialNo || "",
              taxCat1_Cgst: ItemDataByid.taxCat1_Cgst || "",
              taxCat1_Sgst: ItemDataByid.taxCat1_Sgst || "",
              taxCat1_Igst: ItemDataByid.taxCat1_Igst || "",
              taxCat1_Cess: ItemDataByid.taxCat1_Cess || "",
              taxCat2_Cgst: ItemDataByid.taxCat2_Cgst || "",
              taxCat2_Sgst: ItemDataByid.taxCat2_Sgst || "",
              taxCat2_Igst: ItemDataByid.taxCat2_Igst || "",
              taxCat2_Cess: ItemDataByid.taxCat2_Cess || "",
              rowIndex: 0,
            };
            items.push(newRow);
          }
        }
        setItemsArray(items);
        var upload = await SaveLensItemData(items);
      } else {
        alert("Failed to upload CSV file!");
        setIsLoading(false);
      }
    } catch (error) {
      alert("Failed to upload CSV file!");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const SaveLensItemData = async (items) => {
    setIsLoading(true);
    if (items && items.length > 0) {
      var ProductTempData = await Transaction.SetProductTempDataForMultiple(
        items,
        ReferenceNumber
      );
      if (ProductTempData.isSuccess === false) {
        console.log("API call failed. Response:", ProductTempData);
      } else if (ProductTempData.isSuccess === true) {
        setChangeInData(false);
        console.log("Product Temp Data saved successfully.");
        setshowSuccess(true);
        setIsLoading(false);
        Swal.fire({
          icon: "success",
          title: "Product Imported",
          text: `${items.length} item(s) imported successfully.`,
          timer: 4000,
          showConfirmButton: false,
          timerProgressBar: true,
          width: "250px",
          customClass: {
            title: "swal2-custom-title",
            confirmButton: "my-confirm-button",
            cancelButton: "my-cancel-button",
            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
        setTimeout(() => {
          onClose(false);
        }, 500);
        await GetProductDataFunction();
      }
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ color: "white" }}>
        <span
          className="close"
          style={{ top: "-10px", right: "5px" }}
          onClick={handleClose}
        >
          &times;
        </span>
        {/* <h4>Upload CSV File</h4> */}
        <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
          <h4>Upload CSV File</h4>
          <button
            onClick={() => {
              const link = document.createElement("a");
              link.href = "/ImportItemForLensOrder.csv";
              link.download = "ImportItemForLensOrder.csv"; // Optional
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            Download CSV
          </button>
        </div>

        <div className="form-group">
          <label style={{ marginRight: "10px" }}>Select CSV file:- </label>
          <input
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleFileChange}
            style={{
              margin: "10px 0",
              left: "30px",
              cursor: "pointer",
              height: "45px",
            }} // Add your desired styles here
          />
        </div>
        {showSuccess && (
          <span className="upload-message">CSV file uploaded</span>
        )}
        <button onClick={handleCSVUpload}>Upload CSV</button>
      </div>
      {isLoading && <Loader />}
    </div>
  );
};

export default CsvModalSaleInvoice;
